
import { useQuery, useMutation } from '@tanstack/react-query'
import { onFormError } from '../../core/utils/hooks'
import { notification } from 'antd'

import {
  loadCampaign,
  createVendorFromCampaign
} from '../../api/unrestricted/campaign'

const key = 'unrestricted.campaign'

export const useFetch = (hash) => {
  return useQuery({
    queryKey: [key],
    queryFn: () => loadCampaign(hash)
  })
}

export const usePostForm = () => {
  return useMutation({
    mutationFn: createVendorFromCampaign,
    onSuccess: () => {
      notification.success({
        message: 'Registered',
        description: 'Successful registration'
      })
    },
    onError: onFormError
  })
}
